import PropTypes from 'prop-types'

const CurrentFilterListPropType = PropTypes.object

export default CurrentFilterListPropType